export default __webpack_public_path__ + "static/media/gmail.16286b30.svg";